import { get, find, flow, defaultTo, curry, toLower } from 'lodash/fp';

export const getAttribute = curry((name, obj) => (
  flow(
    get('attributes'),
    find(attr => toLower(get('name', attr)) === toLower(name)),
  )(obj)));

export const getNormalizedAttributeValue = curry((name, obj) => (
  flow(
    getAttribute(name),
    get('normalizedValue'),
  )(obj)));

export const getAttributeValue = curry((name, obj) => (
  flow(
    getAttribute(name),
    get('value'),
  )(obj)));

export const transformAttributeValue = curry((transformer, name, obj) => (
  flow(
    getAttributeValue(name),
    transformer,
  )(obj)));

export const getAttributeValueOr = curry((defaultValue, name, obj) => (
  flow(
    getAttributeValue(name),
    defaultTo(defaultValue),
  )(obj)));
